export const US_PHONE_REGEX =
  /^(\+\d{1,2}\s)?\(?[2-9]\d{2}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

export const NAME_PATTERN = /^[a-zA-Z\s'-.]+$/;

export const ADDRESS_PATTERN = /^[^@]*$/;

export const EMAIL_REGEX = /^[A-Z0-9._%+-]+@([A-Z0-9][A-Z0-9.]*\.[A-Z]{2,4})$/i;

export const ZIP_CODE_REGEX = /^[0-9]{5}$/i;

export const US_PHONE_MASK = [
  '(',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  ')',
  ' ',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  '-',
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
  /[0-9]/,
];
